/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemArtifactRequestFromJSON(json) {
    return WallItemArtifactRequestFromJSONTyped(json, false);
}
export function WallItemArtifactRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'artifactId': !exists(json, 'artifact_id') ? undefined : json['artifact_id'],
        'requestedForUserId': !exists(json, 'requested_for_user_id') ? undefined : json['requested_for_user_id'],
        'requestedForDeviceId': !exists(json, 'requested_for_device_id') ? undefined : json['requested_for_device_id'],
        'artifactType': !exists(json, 'artifact_type') ? undefined : json['artifact_type'],
    };
}
export function WallItemArtifactRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'artifact_id': value.artifactId,
        'requested_for_user_id': value.requestedForUserId,
        'requested_for_device_id': value.requestedForDeviceId,
        'artifact_type': value.artifactType,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemArtifactRequestArtifactType;
(function (WallItemArtifactRequestArtifactType) {
    WallItemArtifactRequestArtifactType["BOOKMARK"] = "BOOKMARK";
    WallItemArtifactRequestArtifactType["GPSPOSITION"] = "GPS_POSITION";
    WallItemArtifactRequestArtifactType["LAYOUTESTIMATION"] = "LAYOUT_ESTIMATION";
    WallItemArtifactRequestArtifactType["MESH"] = "MESH";
    WallItemArtifactRequestArtifactType["RECORDING"] = "RECORDING";
    WallItemArtifactRequestArtifactType["ROOMOUTCOMEREPORT"] = "ROOM_OUTCOME_REPORT";
    WallItemArtifactRequestArtifactType["SCENESHOT"] = "SCENESHOT";
    WallItemArtifactRequestArtifactType["STREEMSHOT"] = "STREEMSHOT";
    WallItemArtifactRequestArtifactType["TEXTUREDMESH"] = "TEXTURED_MESH";
    WallItemArtifactRequestArtifactType["TRANSCRIPTION"] = "TRANSCRIPTION";
    WallItemArtifactRequestArtifactType["UNKNOWN"] = "UNKNOWN";
})(WallItemArtifactRequestArtifactType || (WallItemArtifactRequestArtifactType = {}));
//# sourceMappingURL=WallItemArtifactRequest.js.map